export enum AuthLoginFlag {
  SHOW_TERMS_MODAL,
  ACTION_TERMS_MODAL,
  LOADING,
}